import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Vulnerability = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Vulnerability' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,0 L12,24 L12,0 Z M0,12 L24,12 L0,12 Z M17,12 C17,9.243 14.757,7 12,7 C9.243,7 7,9.243 7,12 C7,14.757 9.243,17 12,17 C14.757,17 17,14.757 17,12 L17,12 Z M12,21 C7.038,21 3,16.963 3,12 C3,7.037 7.038,3 12,3 C16.962,3 21,7.037 21,12 C21,16.963 16.962,21 12,21 L12,21 Z' />
  </StyledIcon>
);
